import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const DetallesAlerta = ({ open, onClose, data }) => {

    return (

        <Dialog
            open={open}
            onClose={onClose}
            fullScreen
        >

            {/* BODY */}

            <DialogContent
                sx={{
                    paddingTop: 4,  // equivalente a 32px
                    paddingX: 3,
                }}
            >

                <div
                    dangerouslySetInnerHTML={{ __html: data?.body || "<p>Sin contenido</p>" }}
                    style={{
                        maxHeight: '75vh',
                        overflow: 'auto',
                        wordBreak: 'break-word',
                        padding: '1rem',
                        backgroundColor: '#f9f9f9',
                        borderRadius: '8px',
                        margin: '0 auto',
                    }}
                />

                <DialogActions
                    sx={{ justifyContent: 'center' }}
                >

                    <Button 
                        onClick={onClose}
                        variant="contained" 
                        color="primary"
                        startIcon={<ArrowBackIcon />}
                        sx={{
                            fontSize: '1.2rem',
                        }}
                    >
                        Regresar
                    </Button>

                </DialogActions>

            </DialogContent>

        </Dialog>

    )

}

export default DetallesAlerta